type GetChatNamespaceParams = {
    namespaceFromUserViewContext: string | number | boolean | null | undefined;
};

const getChatNamespace = ({ namespaceFromUserViewContext }: GetChatNamespaceParams): string => {
    return typeof namespaceFromUserViewContext === 'string' &&
        namespaceFromUserViewContext.length > 0
        ? namespaceFromUserViewContext
        : 'workflow';
};

export default getChatNamespace;
